module.exports = __webpack_public_path__ + "media/icon_transaction/rabit_4-8c585292.png";